import Header from '@/components/Header/Header';
import { createFileRoute } from '@tanstack/react-router';
import { FormattedMessage, useIntl } from 'react-intl';
import MarkdownContent from '@/MarkdownContent.tsx';
import { useGetTenant } from '@/api/trafikportalen';
import { Loading } from '@/components/Loading.tsx';
import { DocumentHead } from '@/components/core/DocumentHead';

//TODO: Use permission 'tenantsettings:read' or similar when available
export const Route = createFileRoute('/$tenantId/_layout/privacy-policy/')({
  component: PrivacyPolicy,
});

function PrivacyPolicy() {
  const { data: tenant, isLoading } = useGetTenant();
  const { formatMessage } = useIntl();

  if (isLoading || !tenant) {
    return <Loading />;
  }

  return (
    <div className="overflow-y-auto">
      <DocumentHead
        titleKey="page.privacyPolicy.title"
        descriptionKey="page.privacyPolicy.description"
      />
      <Header title={<FormattedMessage defaultMessage="Integritetspolicy" />} />
      <section className="mb-12 flex justify-center p-4 md:flex-row md:p-8 lg:mb-0">
        <MarkdownContent
          markdownText={
            tenant.privacy_policy ||
            formatMessage({
              defaultMessage: 'Det finns ingen integritetspolicy ännu.',
            })
          }
        />
      </section>
    </div>
  );
}
